import { Injectable } from '@angular/core';
import { Resolve, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { WhatsappTrialService } from './whatsapp-trial.service';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WhatsappTrialResolver implements Resolve<boolean> {
  constructor(
    private whatsappTrialService: WhatsappTrialService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const redirectTo = this.obtenhaDestino(route.queryParamMap.get('redirectTo'));

    // Converte a Promise em Observable
    return new Observable<boolean>(observer => {
      this.whatsappTrialService.obterStatusTrial()
        .then((resposta: any) => {
          if (resposta.trialAtivo) {
            // Se o trial estiver ativo, redirecionar para o destino solicitado
            this.router.navigateByUrl(redirectTo);
            observer.next(false);
            observer.complete();
          } else {
            // Se o trial não estiver ativo, permitir o acesso à página de paywall
            observer.next(true);
            observer.complete();
          }
        })
        .catch((erro) => {
          console.error('Erro ao verificar status do trial:', erro);
          // Em caso de erro, permitir o acesso à página de paywall
          observer.next(true);
          observer.complete();
        });
    });
  }

  private obtenhaDestino(redirectTo: string | null): string {
    if (redirectTo && redirectTo.startsWith('cloud-whatsapp/')) {
      return `/admin/${redirectTo}`;
    }

    return '/admin/cloud-whatsapp/config';
  }
}
